import { render, staticRenderFns } from "./Corp.vue?vue&type=template&id=2dfa6eef"
import script from "./Corp.vue?vue&type=script&lang=js"
export * from "./Corp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports